module.exports = __webpack_public_path__ + "img/jk2.d562c758.png";